import { useState } from "react"
import {Menu, X, Globe} from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import VisionModal from '@/components/VisionModal'

type Lang = "en" | "ja"

const translations: Record<Lang, Record<string, string>> = {
  en: {
    // Nav
    home: "Home",
    about: "About",
    roadmap: "Roadmap",
    tokenomics: "Tokenomics",
    howToBuy: "How to Buy",
    mission: "Mission",
    donate: "Donate",
    langLabel: "JP",
    launchAlert: "LAUNCH COMING SOON!",

    // Hero
    heroTitle: "SHIKOKU INU COIN",
    heroSubtitle: "To The Moon!",
    heroDesc: "Help navigate Shinu as he embarks on his journey throughout Japan 🇯🇵",
    buyBtn: "BUY $SHINU",
    communityBtn: "JOIN COMMUNITY",

    // About
    aboutTitle1: "Meet Shinu the",
    aboutTitle2: "Shikoku Inu Puppy",
    aboutIntro: "Meet Shinu \u2014 the goodest boi on the blockchain.",
    aboutP1: "Birthed from a legendary Kishu Inu and Shiba Inu, Shikoku Inu came into this world as the perfect mix of loyalty, chaos, and pure meme spirit.",
    aboutP2: "While others chase hype, Shikoku is bringing back those pure 2021 vibes to the memecoin space \u2014 diamond hands, community raids, moon missions, and that unbreakable pack energy we all fell in love with.",
    aboutP3: "No fake utility. No rugs. Just one ridiculously good boy leading his pack with maximum loyalty and good vibes only.",
    aboutP4a: "Shikoku isn't just another dog coin.",
    aboutP4b: "He's the goodest boi who reminds us why we're here: fun, chaos, loyalty, and the belief that one legendary dog can rally an army and send everyone to the moon.",
    aboutCta1: "Join the pack.",
    aboutCta2: "HODL the goodest boi.",
    aboutCta3: "Let's make 2021 vibes great again.",
    aboutTagline: "$SHINU \u2014 Because every blockchain deserves its goodest boi.",

    // Roadmap
    roadmapTitle1: "Our",
    roadmapTitle2: "Roadmap",
    phase1Title: "PHASE 1: LAUNCH",
    step1: "Website Launch & Branding",
    step2: "Smart Contract Deployment",
    step3: "Community Building (Twitter, Telegram)",
    step4: "Initial DEX Listing",
    step5: "CoinGecko & CMC",
    step6: "Embark on journey throughout Japan 🇯🇵",
    step7: "Merch Store",
    step8: "Choose Animal Rescue",

    // Roadmap Phase 2
    phase2Title: "PHASE 2: DEVELOPMENT",
    phase2Step1: "Shikoku Tools",
    phase2Step2: "Shikoku Story",
    phase2Step3: "Shikoku Comics",
    phase2Step4: "Marketing Campaigns & Contests",

    // Tokenomics
    tokenDistribution: "Token Distribution",
    liquidityPool: "Liquidity Pool",
    airdrops: "Airdrops",
    marketing: "Marketing",
    tokenDetails: "Token Details",
    totalSupply: "Total Supply:",
    tokenName: "Token Name:",
    symbol: "Symbol:",
    network: "Network:",
    lpBurned: "LP BURNED FOREVER",
    lpBurnedDesc: "Liquidity locked permanently. No rug pulls, only moon missions!",
    taxStructure: "Tax Structure",
    buyTax: "BUY TAX",
    sellTax: "SELL TAX",
    zeroFeesBuy: "Zero fees on purchases!",
    zeroFeesSell: "Zero fees on sales!",

    // How to Buy
    howToBuyTitle: "How to Buy",
    howToBuyStep1Title: "1. Upon Launch on Pump.Fun",
    howToBuyStep1Desc: "You can purchase directly from Pump Fun using a Phantom wallet and $Sol.",
    howToBuyStep2Title: "2. Upon Pump Fun Graduation",
    howToBuyStep2Desc: "You can purchase from Coinbase (US) with Apple Pay, debit card, or USDC.",

    // Mission
    missionTitle: "$SHINU MISSION",
    missionP1: "We're not just another meme coin chasing pumps. We're building a MOVEMENT.",
    missionP2: "The Shikoku Pack is united by one powerful belief: crypto should make the world better. We're decentralization maximalists who believe financial freedom isn't just about getting rich—it's about creating real change.",
    missionP3: "Every transaction, every holder, every moon mission brings us closer to our ultimate goal: directing 100% of Creator Fees from Pump.Fun to rescue dogs in need through verified 501c3 shelters.",
    missionP4: "While others promise fake utility and empty roadmaps, we're putting our money where our bark is. Because the goodest boi deserves a community that gives back to ALL good bois.",
    missionCta: "Join the pack. HODL with purpose. Change lives—one paw at a time.",

    // Best Friends Donation
    bestFriendsTitle: "Support Best Friends Animal Society",
    bestFriendsSubtitle: "America's Largest No-Kill Shelter",
    bestFriendsDesc: "While we work toward our long-term goal of directing Creator Fees to dog rescues, you can make an immediate impact TODAY by donating crypto directly to Best Friends Animal Society—the nation's largest no-kill sanctuary saving thousands of dogs, cats, and other animals every year.",
    bestFriendsCta: "Every crypto donation helps save lives. Join the pack in supporting this incredible mission.",
    donateButton: "DONATE CRYPTO TO BEST FRIENDS",
    bestFriendsDisclaimer: "Disclaimer: Shikoku Inu is not affiliated with Best Friends Animal Society. Both are separate entities and unrelated.",

    // Socials
    socialsTitle: "Follow the Pack",
    socialsSubtitle: "Stay connected with the Shikoku Inu community",
    comingSoon: "Coming Soon",
    socials: "Socials",
    vision: "Shikoku's Vision",
    shop: "Shop",

    // Vision Modal
    visionTitle: "Shikoku's Vision:",
    visionSubtitle: "A Timeless Tale of Loyalty, Freedom, and Decentralized Wisdom",

    // Announcement
    telegramAnnouncement: "TELEGRAM WILL BE OPENING MONDAY 4/20",

    // Breed Info
    breedInfo: "The Shikoku (or Shikoku Ken) is a rare, medium-sized Japanese dog breed from the island of Shikoku.",

    // Footer
    footerDesc: "Join our pack and be part of the most adorable crypto revolution!",
    footerCopyright: "\u00a9 2026 Shikoku Inu Coin. All rights reserved.",
    footerDisclaimer: "$SHINU is a meme coin with no intrinsic value or expectation of financial return. This is for entertainment purposes only. DYOR!",
  },
  ja: {
    // Nav
    home: "\u30db\u30fc\u30e0",
    about: "\u6982\u8981",
    roadmap: "\u30ed\u30fc\u30c9\u30de\u30c3\u30d7",
    tokenomics: "\u30c8\u30fc\u30af\u30ce\u30df\u30af\u30b9",
    howToBuy: "\u8cfc\u5165\u65b9\u6cd5",
    mission: "\u30df\u30c3\u30b7\u30e7\u30f3",
    donate: "\u5bc4\u4ed8",
    langLabel: "EN",
    launchAlert: "\u30ed\u30fc\u30f3\u30c1\u8fd1\u65e5\u516c\u958b\uff01",

    // Hero
    heroTitle: "SHIKOKU INU COIN",
    heroSubtitle: "\u6708\u3078\u884c\u3053\u3046\uff01",
    heroDesc: "\u30d6\u30ed\u30c3\u30af\u30c1\u30a7\u30fc\u30f3\u4e0a\u3067\u6700\u9ad8\u306e\u30ef\u30f3\u30b3\uff01\u4ef2\u9593\u306b\u52a0\u308f\u3063\u3066\u3001\u4e00\u7dd2\u306b\u5229\u76ca\u3092\u7372\u5f97\u3057\u3088\u3046\uff01",
    buyBtn: "$SHINU\u3092\u8cfc\u5165",
    communityBtn: "\u30b3\u30df\u30e5\u30cb\u30c6\u30a3\u306b\u53c2\u52a0",

    // About
    aboutTitle1: "Shinu\u306b\u4f1a\u304a\u3046",
    aboutTitle2: "\u56db\u56fd\u72ac\u306e\u5b50\u72ac",
    aboutIntro: "Shinu\u306b\u4f1a\u304a\u3046 \u2014 \u30d6\u30ed\u30c3\u30af\u30c1\u30a7\u30fc\u30f3\u4e0a\u3067\u6700\u9ad8\u306e\u30ef\u30f3\u30b3\u3002",
    aboutP1: "\u4f1d\u8aac\u306e\u7d00\u5dde\u72ac\u3068\u67f4\u72ac\u304b\u3089\u751f\u307e\u308c\u305fShikoku Inu\u306f\u3001\u5fe0\u8aa0\u3001\u6df7\u6c8c\u3001\u305d\u3057\u3066\u7d14\u7c8b\u306a\u30df\u30fc\u30e0\u30b9\u30d4\u30ea\u30c3\u30c8\u306e\u5b8c\u74a7\u306a\u30df\u30c3\u30af\u30b9\u3068\u3057\u3066\u3053\u306e\u4e16\u306b\u8a95\u751f\u3057\u307e\u3057\u305f\u3002",
    aboutP2: "\u4ed6\u304c\u30cf\u30a4\u30d7\u3092\u8ffd\u3044\u304b\u3051\u308b\u4e2d\u3001Shikoku\u306f\u30df\u30fc\u30e0\u30b3\u30a4\u30f3\u306e\u4e16\u754c\u306b\u7d14\u7c8b\u306a2021\u5e74\u306e\u30d0\u30a4\u30d6\u30b9\u3092\u53d6\u308a\u623b\u3057\u3066\u3044\u307e\u3059 \u2014 \u30c0\u30a4\u30e4\u30e2\u30f3\u30c9\u30cf\u30f3\u30ba\u3001\u30b3\u30df\u30e5\u30cb\u30c6\u30a3\u30ec\u30a4\u30c9\u3001\u30e0\u30fc\u30f3\u30df\u30c3\u30b7\u30e7\u30f3\u3001\u305d\u3057\u3066\u79c1\u305f\u3061\u304c\u604b\u306b\u843d\u3061\u305f\u3042\u306e\u58ca\u308c\u306a\u3044\u30d1\u30c3\u30af\u30a8\u30ca\u30b8\u30fc\u3002",
    aboutP3: "\u507d\u306e\u30e6\u30fc\u30c6\u30a3\u30ea\u30c6\u30a3\u306a\u3057\u3002\u30e9\u30b0\u306a\u3057\u3002\u305f\u3060\u4e00\u5339\u306e\u3068\u3093\u3067\u3082\u306a\u304f\u826f\u3044\u5b50\u304c\u3001\u6700\u5927\u306e\u5fe0\u8aa0\u3068\u826f\u3044\u30d0\u30a4\u30d6\u30b9\u3060\u3051\u3067\u7fa4\u308c\u3092\u7387\u3044\u3066\u3044\u307e\u3059\u3002",
    aboutP4a: "Shikoku\u306f\u305f\u3060\u306e\u72ac\u30b3\u30a4\u30f3\u3067\u306f\u3042\u308a\u307e\u305b\u3093\u3002",
    aboutP4b: "\u5f7c\u306f\u79c1\u305f\u3061\u304c\u3053\u3053\u306b\u3044\u308b\u7406\u7531\u3092\u601d\u3044\u51fa\u3055\u305b\u3066\u304f\u308c\u308b\u6700\u9ad8\u306e\u30ef\u30f3\u30b3\u3067\u3059\uff1a\u697d\u3057\u3055\u3001\u6df7\u6c8c\u3001\u5fe0\u8aa0\u3001\u305d\u3057\u3066\u4e00\u5339\u306e\u4f1d\u8aac\u306e\u72ac\u304c\u8ecd\u3092\u7d50\u96c6\u3057\u3001\u7686\u3092\u6708\u306b\u9001\u308c\u308b\u3068\u3044\u3046\u4fe1\u5ff5\u3002",
    aboutCta1: "\u7fa4\u308c\u306b\u52a0\u308f\u308d\u3046\u3002",
    aboutCta2: "\u6700\u9ad8\u306e\u30ef\u30f3\u30b3\u3092HODL\u3057\u3088\u3046\u3002",
    aboutCta3: "2021\u5e74\u306e\u30d0\u30a4\u30d6\u30b9\u3092\u518d\u3073\u7d20\u6674\u3089\u3057\u304f\u3057\u3088\u3046\u3002",
    aboutTagline: "$SHINU \u2014 \u3059\u3079\u3066\u306e\u30d6\u30ed\u30c3\u30af\u30c1\u30a7\u30fc\u30f3\u306b\u6700\u9ad8\u306e\u30ef\u30f3\u30b3\u3092\u3002",

    // Roadmap
    roadmapTitle1: "",
    roadmapTitle2: "\u30ed\u30fc\u30c9\u30de\u30c3\u30d7",
    phase1Title: "\u30d5\u30a7\u30fc\u30ba1: \u30ed\u30fc\u30f3\u30c1",
    step1: "\u30a6\u30a7\u30d6\u30b5\u30a4\u30c8\u30ed\u30fc\u30f3\u30c1 & \u30d6\u30e9\u30f3\u30c7\u30a3\u30f3\u30b0",
    step2: "\u30b9\u30de\u30fc\u30c8\u30b3\u30f3\u30c8\u30e9\u30af\u30c8\u30c7\u30d7\u30ed\u30a4",
    step3: "\u30b3\u30df\u30e5\u30cb\u30c6\u30a3\u69cb\u7bc9 (Twitter, Telegram)",
    step4: "\u521d\u56deDEX\u4e0a\u5834",
    step5: "CoinGecko & CMC",
    step6: "日本中を旅する 🇯🇵",
    step7: "グッズストア",
    step8: "動物レスキューを選ぶ",

    // Roadmap Phase 2
    phase2Title: "フェーズ2: 開発",
    phase2Step1: "四国ツールズ",
    phase2Step2: "四国ストーリー",
    phase2Step3: "四国コミックス",
    phase2Step4: "マーケティングキャンペーン & コンテスト",

    // Tokenomics
    tokenDistribution: "\u30c8\u30fc\u30af\u30f3\u914d\u5206",
    liquidityPool: "\u6d41\u52d5\u6027\u30d7\u30fc\u30eb",
    airdrops: "\u30a8\u30a2\u30c9\u30ed\u30c3\u30d7",
    marketing: "\u30de\u30fc\u30b1\u30c6\u30a3\u30f3\u30b0",
    tokenDetails: "\u30c8\u30fc\u30af\u30f3\u8a73\u7d30",
    totalSupply: "\u7dcf\u4f9b\u7d66\u91cf:",
    tokenName: "\u30c8\u30fc\u30af\u30f3\u540d:",
    symbol: "\u30b7\u30f3\u30dc\u30eb:",
    network: "\u30cd\u30c3\u30c8\u30ef\u30fc\u30af:",
    lpBurned: "LP\u6c38\u4e45\u30d0\u30fc\u30f3",
    lpBurnedDesc: "\u6d41\u52d5\u6027\u306f\u6c38\u4e45\u306b\u30ed\u30c3\u30af\u3002\u30e9\u30b0\u306a\u3057\u3001\u30e0\u30fc\u30f3\u30df\u30c3\u30b7\u30e7\u30f3\u306e\u307f\uff01",
    taxStructure: "\u7a0e\u69cb\u9020",
    buyTax: "\u8cfc\u5165\u7a0e",
    sellTax: "\u58f2\u5374\u7a0e",
    zeroFeesBuy: "\u8cfc\u5165\u6642\u306e\u624b\u6570\u6599\u30bc\u30ed\uff01",
    zeroFeesSell: "\u58f2\u5374\u6642\u306e\u624b\u6570\u6599\u30bc\u30ed\uff01",

    // How to Buy
    howToBuyTitle: "\u8cfc\u5165\u65b9\u6cd5",
    howToBuyStep1Title: "1. Pump.Fun\u30ed\u30fc\u30f3\u30c1\u6642",
    howToBuyStep1Desc: "Phantom\u30a6\u30a9\u30ec\u30c3\u30c8\u3068$Sol\u3092\u4f7f\u7528\u3057\u3066\u3001Pump Fun\u304b\u3089\u76f4\u63a5\u8cfc\u5165\u3067\u304d\u307e\u3059\u3002",
    howToBuyStep2Title: "2. Pump Fun\u5352\u696d\u5f8c",
    howToBuyStep2Desc: "Coinbase\uff08\u7c73\u56fd\uff09\u304b\u3089Apple Pay\u3001\u30c7\u30d3\u30c3\u30c8\u30ab\u30fc\u30c9\u3001\u307e\u305f\u306fUSDC\u3067\u8cfc\u5165\u3067\u304d\u307e\u3059\u3002",

    // Mission
    missionTitle: "$SHINU\u30df\u30c3\u30b7\u30e7\u30f3",
    missionP1: "\u79c1\u305f\u3061\u306f\u5358\u306a\u308b\u30dd\u30f3\u30d7\u3092\u8ffd\u3044\u304b\u3051\u308b\u30df\u30fc\u30e0\u30b3\u30a4\u30f3\u3067\u306f\u3042\u308a\u307e\u305b\u3093\u3002\u79c1\u305f\u3061\u306f\u30e0\u30fc\u30d6\u30e1\u30f3\u30c8\u3092\u69cb\u7bc9\u3057\u3066\u3044\u307e\u3059\u3002",
    missionP2: "Shikoku\u30d1\u30c3\u30af\u306f\u4e00\u3064\u306e\u5f37\u529b\u306a\u4fe1\u5ff5\u3067\u7d50\u3070\u308c\u3066\u3044\u307e\u3059\uff1a\u6697\u53f7\u306f\u4e16\u754c\u3092\u3088\u308a\u826f\u304f\u3059\u308b\u3079\u304d\u3067\u3059\u3002\u79c1\u305f\u3061\u306f\u5206\u6563\u5316\u306e\u6700\u5927\u4e3b\u7fa9\u8005\u3067\u3042\u308a\u3001\u91d1\u878d\u306e\u81ea\u7531\u306f\u5358\u306b\u91d1\u6301\u3061\u306b\u306a\u308b\u3053\u3068\u3067\u306f\u306a\u304f\u3001\u771f\u306e\u5909\u5316\u3092\u751f\u307f\u51fa\u3059\u3053\u3068\u3060\u3068\u4fe1\u3058\u3066\u3044\u307e\u3059\u3002",
    missionP3: "\u3059\u3079\u3066\u306e\u53d6\u5f15\u3001\u3059\u3079\u3066\u306e\u30db\u30eb\u30c0\u30fc\u3001\u3059\u3079\u3066\u306e\u30e0\u30fc\u30f3\u30df\u30c3\u30b7\u30e7\u30f3\u304c\u3001\u79c1\u305f\u3061\u306e\u7a76\u6975\u306e\u76ee\u6a19\u306b\u8fd1\u3065\u3051\u307e\u3059\uff1aPump.Fun\u304b\u3089\u306e\u30af\u30ea\u30a8\u30a4\u30bf\u30fc\u30d5\u30a3\u30fc\u306e100%\u3092\u3001\u8a8d\u8a3c\u3055\u308c\u305f501c3\u30b7\u30a7\u30eb\u30bf\u30fc\u3092\u901a\u3058\u3066\u56f0\u3063\u3066\u3044\u308b\u72ac\u3092\u6551\u3046\u305f\u3081\u306b\u5bc4\u4ed8\u3059\u308b\u3053\u3068\u3002",
    missionP4: "\u4ed6\u304c\u507d\u306e\u30e6\u30fc\u30c6\u30a3\u30ea\u30c6\u30a3\u3084\u7a7a\u306e\u30ed\u30fc\u30c9\u30de\u30c3\u30d7\u3092\u7d04\u675f\u3059\u308b\u4e2d\u3001\u79c1\u305f\u3061\u306f\u884c\u52d5\u3067\u793a\u3057\u307e\u3059\u3002\u306a\u305c\u306a\u3089\u3001\u6700\u9ad8\u306e\u30ef\u30f3\u30b3\u306f\u6069\u8fd4\u3057\u3092\u3059\u308b\u30b3\u30df\u30e5\u30cb\u30c6\u30a3\u306b\u3075\u3055\u308f\u3057\u3044\u304b\u3089\u3067\u3059\u3002",
    missionCta: "\u7fa4\u308c\u306b\u52a0\u308f\u308d\u3046\u3002\u76ee\u7684\u3092\u6301\u3063\u3066HODL\u3057\u3088\u3046\u3002\u4e00\u6b69\u305a\u3064\u547d\u3092\u5909\u3048\u3088\u3046\u3002",

    // Best Friends Donation
    bestFriendsTitle: "\u30d9\u30b9\u30c8\u30d5\u30ec\u30f3\u30ba\u30a2\u30cb\u30de\u30eb\u30bd\u30b5\u30a8\u30c6\u30a3\u3092\u652f\u63f4",
    bestFriendsSubtitle: "\u30a2\u30e1\u30ea\u30ab\u6700\u5927\u306e\u30ce\u30fc\u30ad\u30eb\u30b7\u30a7\u30eb\u30bf\u30fc",
    bestFriendsDesc: "\u30af\u30ea\u30a8\u30a4\u30bf\u30fc\u30d5\u30a3\u30fc\u3092\u72ac\u306e\u6551\u52a9\u306b\u5411\u3051\u308b\u9577\u671f\u76ee\u6a19\u306b\u5411\u3051\u3066\u52aa\u529b\u3057\u3066\u3044\u308b\u9593\u3001\u4eca\u65e5\u3059\u3050\u306b\u30d9\u30b9\u30c8\u30d5\u30ec\u30f3\u30ba\u30a2\u30cb\u30de\u30eb\u30bd\u30b5\u30a8\u30c6\u30a3\u306b\u6697\u53f7\u8cc7\u7523\u3092\u5bc4\u4ed8\u3059\u308b\u3053\u3068\u3067\u3001\u5373\u5ea7\u306b\u5f71\u97ff\u3092\u4e0e\u3048\u308b\u3053\u3068\u304c\u3067\u304d\u307e\u3059\u3002\u30d9\u30b9\u30c8\u30d5\u30ec\u30f3\u30ba\u306f\u3001\u6bcf\u5e74\u4f55\u5343\u982d\u3082\u306e\u72ac\u3001\u732b\u3001\u305d\u306e\u4ed6\u306e\u52d5\u7269\u3092\u6551\u3063\u3066\u3044\u308b\u5168\u7c73\u6700\u5927\u306e\u30ce\u30fc\u30ad\u30eb\u4fdd\u8b77\u65bd\u8a2d\u3067\u3059\u3002",
    bestFriendsCta: "\u6697\u53f7\u8cc7\u7523\u3067\u306e\u5bc4\u4ed8\u306f\u547d\u3092\u6551\u3046\u624b\u52a9\u3051\u3068\u306a\u308a\u307e\u3059\u3002\u3053\u306e\u7d20\u6674\u3089\u3057\u3044\u30df\u30c3\u30b7\u30e7\u30f3\u3092\u652f\u63f4\u3059\u308b\u305f\u3081\u306b\u7fa4\u308c\u306b\u52a0\u308f\u308a\u307e\u3057\u3087\u3046\u3002",
    donateButton: "\u30d9\u30b9\u30c8\u30d5\u30ec\u30f3\u30ba\u306b\u6697\u53f7\u8cc7\u7523\u3067\u5bc4\u4ed8",
    bestFriendsDisclaimer: "\u514d\u8cac\u4e8b\u9805\uff1aShikoku Inu\u306f\u30d9\u30b9\u30c8\u30d5\u30ec\u30f3\u30ba\u30a2\u30cb\u30de\u30eb\u30bd\u30b5\u30a8\u30c6\u30a3\u3068\u63d0\u643a\u3057\u3066\u3044\u307e\u305b\u3093\u3002\u4e21\u8005\u306f\u5225\u3005\u306e\u7d44\u7e54\u3067\u3042\u308a\u3001\u95a2\u4fc2\u306f\u3042\u308a\u307e\u305b\u3093\u3002",

    // Socials
    socialsTitle: "\u30d1\u30c3\u30af\u3092\u30d5\u30a9\u30ed\u30fc",
    socialsSubtitle: "\u56db\u56fd\u72ac\u30b3\u30df\u30e5\u30cb\u30c6\u30a3\u3068\u3064\u306a\u304c\u308d\u3046",
    comingSoon: "\u8fd1\u65e5\u516c\u958b",
    socials: "\u30bd\u30fc\u30b7\u30e3\u30eb",
    vision: "\u56db\u56fd\u72ac\u306e\u30d3\u30b8\u30e7\u30f3",
    shop: "\u30b7\u30e7\u30c3\u30d7",

    // Vision Modal
    visionTitle: "\u56db\u56fd\u72ac\u306e\u30d3\u30b8\u30e7\u30f3:",
    visionSubtitle: "\u5fe0\u8aa0\u3001\u81ea\u7531\u3001\u305d\u3057\u3066\u5206\u6563\u578b\u306e\u77e5\u6075\u306e\u6c38\u9060\u306e\u7269\u8a9e",

    // Announcement
    telegramAnnouncement: "テレグラム 4/20（月）オープン！",

    // Breed Info
    breedInfo: "\u56db\u56fd\u72ac\uff08\u307e\u305f\u306f\u56db\u56fd\u72ac\uff09\u306f\u3001\u56db\u56fd\u5cf6\u539f\u7523\u306e\u5e0c\u5c11\u306a\u4e2d\u578b\u306e\u65e5\u672c\u72ac\u7a2e\u3067\u3059\u3002",

    // Footer
    footerDesc: "\u79c1\u305f\u3061\u306e\u7fa4\u308c\u306b\u52a0\u308f\u3063\u3066\u3001\u6700\u3082\u611b\u3089\u3057\u3044\u6697\u53f7\u901a\u8ca8\u9769\u547d\u306e\u4e00\u54e1\u306b\u306a\u308d\u3046\uff01",
    footerCopyright: "\u00a9 2026 Shikoku Inu Coin. All rights reserved.",
    footerDisclaimer: "$SHINU\u306f\u672c\u8cea\u7684\u306a\u4fa1\u5024\u3084\u91d1\u92ad\u7684\u30ea\u30bf\u30fc\u30f3\u306e\u671f\u5f85\u306e\u306a\u3044\u30df\u30fc\u30e0\u30b3\u30a4\u30f3\u3067\u3059\u3002\u3053\u308c\u306f\u30a8\u30f3\u30bf\u30fc\u30c6\u30a4\u30e1\u30f3\u30c8\u76ee\u7684\u306e\u307f\u3067\u3059\u3002DYOR\uff01",
  },
}

function Home() {
  const [menuOpen, setMenuOpen] = useState(false)
  const [lang, setLang] = useState<Lang>("en")
  const [visionModalOpen, setVisionModalOpen] = useState(false)
  const navigate = useNavigate()

  const t = (key: string) => translations[lang]?.[key] ?? translations.en[key] ?? key

  const toggleLang = () => {
    setLang(prev => (prev === "en" ? "ja" : "en"))
  }

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id)
    element?.scrollIntoView({ behavior: "smooth" })
    setMenuOpen(false)
  }

  return (
    <div className="min-h-screen bg-gradient-to-b from-cyan-50 via-sky-50 to-blue-50">
      {/* Launch Alert Banner */}
      <div className="fixed top-0 left-0 right-0 bg-gradient-to-r from-cyan-500 via-sky-500 to-cyan-500 text-white py-3 px-4 z-[60] shadow-lg animate-pulse">
        <div className="max-w-7xl mx-auto flex items-center justify-center gap-3">
          <span className="text-2xl">🐾</span>
          <span className="text-lg sm:text-xl font-black tracking-wider">{t("launchAlert")}</span>
          <span className="text-2xl">🐾</span>
        </div>
      </div>
      {/* Floating Paw Prints Background */}
      <div className="fixed inset-0 overflow-hidden pointer-events-none opacity-10">
        <div className="absolute top-20 left-10 text-6xl animate-bounce" style={{ animationDelay: "0s", animationDuration: "3s" }}>&#x1f43e;</div>
        <div className="absolute top-40 right-20 text-5xl animate-bounce" style={{ animationDelay: "1s", animationDuration: "4s" }}>&#x1f43e;</div>
        <div className="absolute bottom-40 left-1/4 text-4xl animate-bounce" style={{ animationDelay: "2s", animationDuration: "3.5s" }}>&#x1f43e;</div>
        <div className="absolute top-1/3 right-1/4 text-6xl animate-bounce" style={{ animationDelay: "0.5s", animationDuration: "4.5s" }}>&#x1f43e;</div>
        <div className="absolute bottom-20 right-10 text-5xl animate-bounce" style={{ animationDelay: "1.5s", animationDuration: "3s" }}>&#x1f43e;</div>
      </div>

      {/* Header with Hamburger Menu */}
      <header className="fixed top-12 left-0 right-0 bg-white/90 backdrop-blur-md shadow-lg z-50 border-b-4 border-cyan-400">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            {/* Logo */}
            <div className="flex items-center gap-3">
              <img 
                src="https://static.lumi.new/cf/cf424088f7c8ce8cc0950a48808d2701.webp" 
                alt="Shikoku Inu Logo"
                className="w-12 h-12 rounded-full shadow-lg transform hover:rotate-12 transition-transform object-cover"
              />
              <span className="text-2xl font-black text-gray-800">
                SHIKOKU <span className="text-cyan-500">INU</span>
              </span>
            </div>

            {/* Right side buttons */}
            <div className="flex items-center gap-3">
              {/* Language Toggle */}
              <button
                onClick={toggleLang}
                className="flex items-center gap-1.5 px-3 py-2 rounded-lg bg-cyan-50 text-cyan-600 hover:bg-cyan-100 transition-colors font-black text-sm border-2 border-cyan-300"
                aria-label="Toggle language"
              >
                <Globe size={18} />
                <span>{t("langLabel")}</span>
              </button>

              {/* Hamburger Button */}
              <button
                onClick={() => setMenuOpen(!menuOpen)}
                className="p-2 rounded-lg bg-cyan-500 text-white hover:bg-cyan-600 transition-colors shadow-lg"
                aria-label="Toggle menu"
              >
                {menuOpen ? <X size={28} /> : <Menu size={28} />}
              </button>
            </div>
          </div>
        </div>

        {/* Dropdown Menu */}
        {menuOpen && (
          <div className="bg-white border-t-2 border-cyan-400 shadow-2xl">
            <nav className="max-w-7xl mx-auto px-4 py-4">
              <div className="flex flex-col gap-3 max-h-[calc(100vh-10rem)] overflow-y-auto pr-1 relative">
                {/* Scroll hint */}
                <div className="sticky top-0 z-10 flex items-center justify-center gap-2 pb-2 text-sm font-bold text-cyan-400 animate-bounce sm:hidden">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14"/><path d="m19 12-7 7-7-7"/></svg>
                  Scroll for more
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M12 5v14"/><path d="m19 12-7 7-7-7"/></svg>
                </div>
                <button onClick={() => scrollToSection("hero")} className="text-left text-lg font-bold text-gray-800 hover:text-cyan-500 transition-colors py-2 px-4 rounded-lg hover:bg-cyan-50">
                  {t("home")}
                </button>
                <button onClick={() => scrollToSection("about")} className="text-left text-lg font-bold text-gray-800 hover:text-cyan-500 transition-colors py-2 px-4 rounded-lg hover:bg-cyan-50">
                  {t("about")}
                </button>
                <button onClick={() => scrollToSection("roadmap")} className="text-left text-lg font-bold text-gray-800 hover:text-cyan-500 transition-colors py-2 px-4 rounded-lg hover:bg-cyan-50">
                  {t("roadmap")}
                </button>
                <button onClick={() => scrollToSection("tokenomics")} className="text-left text-lg font-bold text-gray-800 hover:text-cyan-500 transition-colors py-2 px-4 rounded-lg hover:bg-cyan-50">
                  {t("tokenomics")}
                </button>
                <button onClick={() => scrollToSection("howtobuy")} className="text-left text-lg font-bold text-gray-800 hover:text-cyan-500 transition-colors py-2 px-4 rounded-lg hover:bg-cyan-50">
                  {t("howToBuy")}
                </button>
                <button onClick={() => scrollToSection("mission")} className="text-left text-lg font-bold text-gray-800 hover:text-cyan-500 transition-colors py-2 px-4 rounded-lg hover:bg-cyan-50">
                  {t("mission")}
                </button>
                <button onClick={() => scrollToSection("bestfriends")} className="text-left text-lg font-bold text-gray-800 hover:text-cyan-500 transition-colors py-2 px-4 rounded-lg hover:bg-cyan-50">
                  {t("donate")} ❤️
                </button>
                <button onClick={() => scrollToSection("socials")} className="text-left text-lg font-bold text-gray-800 hover:text-cyan-500 transition-colors py-2 px-4 rounded-lg hover:bg-cyan-50">
                  {t("socials")}
                </button>
                <button onClick={() => { setVisionModalOpen(true); setMenuOpen(false); }} className="text-left text-lg font-bold text-cyan-500 hover:text-cyan-600 transition-colors py-2 px-4 rounded-lg hover:bg-cyan-50">
                  {t("vision")}
                </button>
                <a href="https://shikokuinustore.myshopify.com" target="_blank" rel="noopener noreferrer" onClick={() => setMenuOpen(false)} className="text-left text-lg font-bold text-cyan-500 hover:text-cyan-600 transition-colors py-2 px-4 rounded-lg hover:bg-cyan-50">
                  {t("shop")}
                </a>
                {/* Bottom fade gradient to hint more content */}
                <div className="sticky bottom-0 h-6 bg-gradient-to-t from-white to-transparent pointer-events-none sm:hidden" />
              </div>
            </nav>
          </div>
        )}
      </header>

      {/* Hero Section */}
      <section id="hero" className="min-h-screen flex items-center justify-center pt-32 px-4 relative">
        <div className="max-w-6xl mx-auto text-center">
          {/* Dog Image */}
          <div className="mb-8 relative inline-block">
            <div className="absolute -inset-4 bg-gradient-to-r from-cyan-400 via-sky-500 to-blue-500 rounded-full blur-xl opacity-40 animate-pulse"></div>
            <img 
              src="https://static.lumi.new/cf/cf424088f7c8ce8cc0950a48808d2701.webp" 
              alt="Shikoku Inu"
              className="relative w-64 h-64 sm:w-80 sm:h-80 object-cover rounded-full border-4 border-white shadow-2xl transform hover:scale-105 transition-transform"
            />
          </div>

          {/* Title */}
          <h1 className="text-5xl sm:text-7xl font-black text-gray-800 mb-6 leading-tight">
            {t("heroTitle")}
            <span className="block text-4xl sm:text-6xl bg-gradient-to-r from-cyan-500 via-sky-500 to-blue-500 bg-clip-text text-transparent mt-2">
              {t("heroSubtitle")}
            </span>
          </h1>

          <p className="text-xl sm:text-2xl text-gray-600 mb-8 font-bold max-w-2xl mx-auto">
            {t("heroDesc")}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <button className="px-8 py-4 bg-gradient-to-r from-cyan-500 to-sky-500 text-white font-black text-lg rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all border-4 border-white">
              {t("buyBtn")}
            </button>
            <button className="px-8 py-4 bg-white text-cyan-500 font-black text-lg rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all border-4 border-cyan-500">
              {t("communityBtn")}
            </button>
          </div>
        </div>
      </section>

      {/* Telegram Announcement */}
      <div className="relative z-10 py-8 px-4">
        <div className="max-w-5xl mx-auto">
          <div className="relative overflow-hidden bg-gradient-to-r from-gray-900 via-gray-800 to-gray-900 rounded-3xl shadow-2xl border border-cyan-400/30">
            {/* Animated background glow */}
            <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/10 via-sky-500/20 to-cyan-500/10 animate-pulse" />
            <div className="absolute -top-24 -left-24 w-48 h-48 bg-cyan-500/20 rounded-full blur-3xl" />
            <div className="absolute -bottom-24 -right-24 w-48 h-48 bg-sky-500/20 rounded-full blur-3xl" />
            
            {/* Top accent line */}
            <div className="h-1 bg-gradient-to-r from-transparent via-cyan-400 to-transparent" />
            
            <div className="relative px-6 sm:px-12 py-8 sm:py-10">
              {/* Overline label */}
              <div className="flex items-center justify-center gap-3 mb-4">
                <div className="h-px w-8 sm:w-16 bg-gradient-to-r from-transparent to-cyan-400" />
                <span className="text-xs sm:text-sm font-black tracking-[0.3em] text-cyan-400 uppercase">Announcement</span>
                <div className="h-px w-8 sm:w-16 bg-gradient-to-l from-transparent to-cyan-400" />
              </div>
              
              {/* Main headline */}
              <h3 className="text-2xl sm:text-4xl md:text-5xl font-black text-center text-white tracking-tight leading-tight">
                {t("telegramAnnouncement")}
              </h3>
              
              {/* Decorative bottom accent */}
              <div className="flex items-center justify-center gap-2 mt-6">
                <div className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse" />
                <div className="w-2 h-2 rounded-full bg-sky-400 animate-pulse" style={{ animationDelay: '0.2s' }} />
                <div className="w-2 h-2 rounded-full bg-cyan-400 animate-pulse" style={{ animationDelay: '0.4s' }} />
              </div>
            </div>
            
            {/* Bottom accent line */}
            <div className="h-1 bg-gradient-to-r from-transparent via-cyan-400 to-transparent" />
          </div>
        </div>
      </div>

      {/* About Section */}
      <section id="about" className="py-20 px-4 relative">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-5xl sm:text-6xl font-black text-center mb-6 text-gray-800">
            {t("aboutTitle1")}{t("aboutTitle1") ? " " : ""}<span className="text-cyan-500">{t("aboutTitle2")}</span>
          </h2>
          <div className="flex justify-center mb-16">
            <img src="https://static.lumi.new/84/841e862087a1432449ad26f08c7e72c7.webp" alt="Shikoku Inu" className="w-56 h-56 sm:w-80 sm:h-80 object-contain" />
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-3xl p-8 sm:p-12 shadow-xl border-4 border-cyan-300">
              <div className="space-y-6 text-gray-700 text-lg leading-relaxed">
                <p className="text-2xl font-black text-cyan-500">
                  {t("aboutIntro")}
                </p>
                <p>{t("aboutP1")}</p>
                <p>{t("aboutP2")}</p>
                <p>{t("aboutP3")}</p>
                <p>
                  {t("aboutP4a")}<br />
                  {t("aboutP4b")}
                </p>
                <p className="font-black text-gray-800">
                  {t("aboutCta1")}<br />
                  {t("aboutCta2")}<br />
                  {t("aboutCta3")}
                </p>
                <p className="text-xl font-black bg-gradient-to-r from-cyan-500 via-sky-500 to-blue-500 bg-clip-text text-transparent">
                  {t("aboutTagline")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Scrolling Ticker Banner */}
      <div className="bg-white border-y-4 border-cyan-400 overflow-hidden py-4">
        <div className="flex animate-scroll">
          <div className="flex whitespace-nowrap">
            <span className="text-4xl sm:text-5xl font-black text-cyan-500 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-gray-800 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-cyan-500 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-gray-800 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-cyan-500 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-gray-800 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-cyan-500 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-gray-800 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-cyan-500 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-gray-800 px-4">$SHINU</span>
          </div>
          <div className="flex whitespace-nowrap">
            <span className="text-4xl sm:text-5xl font-black text-cyan-500 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-gray-800 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-cyan-500 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-gray-800 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-cyan-500 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-gray-800 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-cyan-500 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-gray-800 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-cyan-500 px-4">$SHINU</span>
            <span className="text-4xl sm:text-5xl font-black text-gray-800 px-4">$SHINU</span>
          </div>
        </div>
      </div>

      {/* Roadmap Section */}
      <section id="roadmap" className="py-20 px-4 bg-gradient-to-r from-cyan-100 to-sky-100 relative">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-5xl sm:text-6xl font-black text-center mb-6 text-gray-800">
            {t("roadmapTitle1")}{t("roadmapTitle1") ? " " : ""}<span className="text-cyan-500">{t("roadmapTitle2")}</span>
          </h2>
          <div className="flex justify-center mb-16">
            <img src="https://static.lumi.new/21/214c8a6b96be39a2679f87adc9712a23.webp" alt="Shikoku Inu Roadmap" className="w-48 h-48 sm:w-64 sm:h-64 object-contain" />
          </div>

          <div className="space-y-8">
            {/* Phase 1 */}
            <div className="bg-white rounded-3xl p-8 shadow-xl border-4 border-cyan-400 transform hover:scale-105 transition-transform">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-16 h-16 bg-gradient-to-br from-cyan-400 to-sky-500 rounded-full flex items-center justify-center text-3xl font-black text-white shadow-lg">
                  1
                </div>
                <div>
                  <h3 className="text-2xl font-black text-cyan-500">{t("phase1Title")}</h3>
                </div>
              </div>
              <ul className="space-y-3 text-lg text-gray-700 ml-20">
                <li className="flex items-center gap-3">
                  <span className="text-green-500 font-black">&#x2713;</span>
                  <span>{t("step1")}</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="text-green-500 font-black">&#x2713;</span>
                  <span>{t("step7")}</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="text-green-500 font-black">&#x2713;</span>
                  <span>{t("step8")}</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="text-sky-500 font-black">&#x25CB;</span>
                  <span>{t("step2")}</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="text-sky-500 font-black">&#x25CB;</span>
                  <span>{t("step3")}</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="text-sky-500 font-black">&#x25CB;</span>
                  <span>{t("step4")}</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="text-sky-500 font-black">&#x25CB;</span>
                  <span>{t("step5")}</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="text-sky-500 font-black">&#x25CB;</span>
                  <span>{t("step6")}</span>
                </li>
              </ul>
            </div>

            {/* Phase 2 */}
            <div className="bg-white rounded-3xl p-8 shadow-xl border-4 border-sky-400 transform hover:scale-105 transition-transform">
              <div className="flex items-center gap-4 mb-4">
                <div className="w-16 h-16 bg-gradient-to-br from-sky-400 to-blue-500 rounded-full flex items-center justify-center text-3xl font-black text-white shadow-lg">
                  2
                </div>
                <div>
                  <h3 className="text-2xl font-black text-sky-500">{t("phase2Title")}</h3>
                </div>
              </div>
              <ul className="space-y-3 text-lg text-gray-700 ml-20">
                <li className="flex items-center gap-3">
                  <span className="text-sky-500 font-black">&#x25CB;</span>
                  <span>{t("phase2Step1")}</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="text-sky-500 font-black">&#x25CB;</span>
                  <span>{t("phase2Step2")}</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="text-sky-500 font-black">&#x25CB;</span>
                  <span>{t("phase2Step3")}</span>
                </li>
                <li className="flex items-center gap-3">
                  <span className="text-sky-500 font-black">&#x25CB;</span>
                  <span>{t("phase2Step4")}</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Tokenomics Section */}
      <section id="tokenomics" className="py-20 px-4 relative">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-5xl sm:text-6xl font-black text-center mb-6 text-gray-800">
            <span className="text-cyan-500">{t("tokenomics")}</span>
          </h2>
          <div className="flex justify-center mb-16">
            <img src="https://static.lumi.new/5d/5d5fabbd020cb4c954e621ce5e9b6875.webp" alt="Shikoku Inu Tokenomics" className="w-48 h-48 sm:w-64 sm:h-64 object-contain" />
          </div>

          <div className="grid md:grid-cols-2 gap-12 items-center">
            {/* Token Distribution */}
            <div className="space-y-6">
              <div className="bg-gradient-to-br from-cyan-400 to-sky-500 rounded-3xl p-8 shadow-2xl border-4 border-white text-white">
                <h3 className="text-3xl font-black mb-6 text-center">{t("tokenDistribution")}</h3>
                <div className="space-y-4">
                  <div className="bg-white/20 backdrop-blur rounded-xl p-4">
                    <div className="flex justify-between items-center mb-2">
                      <span className="font-black text-lg">{t("liquidityPool")}</span>
                      <span className="font-black text-2xl">0%</span>
                    </div>
                    <div className="w-full bg-white/30 rounded-full h-4">
                      <div className="bg-white rounded-full h-4 w-[0%]"></div>
                    </div>
                  </div>

                  <div className="bg-white/20 backdrop-blur rounded-xl p-4">
                    <div className="flex justify-between items-center mb-2">
                      <span className="font-black text-lg">{t("airdrops")}</span>
                      <span className="font-black text-2xl">0%</span>
                    </div>
                    <div className="w-full bg-white/30 rounded-full h-4">
                      <div className="bg-white rounded-full h-4 w-[0%]"></div>
                    </div>
                  </div>

                  <div className="bg-white/20 backdrop-blur rounded-xl p-4">
                    <div className="flex justify-between items-center mb-2">
                      <span className="font-black text-lg">{t("marketing")}</span>
                      <span className="font-black text-2xl">0%</span>
                    </div>
                    <div className="w-full bg-white/30 rounded-full h-4">
                      <div className="bg-white rounded-full h-4 w-[0%]"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Token Details */}
            <div className="space-y-6">
              <div className="bg-white rounded-3xl p-8 shadow-xl border-4 border-cyan-400">
                <h3 className="text-3xl font-black text-cyan-500 mb-6 text-center">{t("tokenDetails")}</h3>
                <div className="space-y-4 text-lg">
                  <div className="flex justify-between items-center p-4 bg-cyan-50 rounded-xl">
                    <span className="font-bold text-gray-700">{t("totalSupply")}</span>
                    <span className="font-black text-cyan-500">1,000,000,000</span>
                  </div>
                  <div className="flex justify-between items-center p-4 bg-pink-50 rounded-xl">
                    <span className="font-bold text-gray-700">{t("tokenName")}</span>
                    <span className="font-black text-pink-500">Shikoku Inu</span>
                  </div>
                  <div className="flex justify-between items-center p-4 bg-purple-50 rounded-xl">
                    <span className="font-bold text-gray-700">{t("symbol")}</span>
                    <span className="font-black text-purple-500">$SHINU</span>
                  </div>
                  <div className="flex justify-between items-center p-4 bg-blue-50 rounded-xl">
                    <span className="font-bold text-gray-700">{t("network")}</span>
                    <span className="font-black text-blue-500">Solana</span>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-r from-green-400 to-emerald-500 rounded-3xl p-8 shadow-xl border-4 border-white text-white text-center">
                <div className="text-6xl mb-4">&#x1f512;</div>
                <h3 className="text-2xl font-black mb-3">{t("lpBurned")}</h3>
                <p className="text-lg font-bold">{t("lpBurnedDesc")}</p>
              </div>
            </div>
          </div>

          {/* Tax Info */}
          <div className="mt-12 bg-white rounded-3xl p-8 shadow-xl border-4 border-cyan-400">
            <h3 className="text-3xl font-black text-center text-gray-800 mb-8">{t("taxStructure")}</h3>
            <div className="grid sm:grid-cols-2 gap-8 max-w-3xl mx-auto">
              <div className="text-center p-6 bg-green-50 rounded-2xl border-2 border-green-400">
                <div className="text-5xl font-black text-green-500 mb-2">0%</div>
                <div className="text-xl font-bold text-gray-700">{t("buyTax")}</div>
                <div className="text-sm text-gray-500 mt-2">{t("zeroFeesBuy")}</div>
              </div>
              <div className="text-center p-6 bg-green-50 rounded-2xl border-2 border-green-400">
                <div className="text-5xl font-black text-green-500 mb-2">0%</div>
                <div className="text-xl font-bold text-gray-700">{t("sellTax")}</div>
                <div className="text-sm text-gray-500 mt-2">{t("zeroFeesSell")}</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How to Buy Section */}
      <section id="howtobuy" className="py-20 px-4 bg-gradient-to-r from-cyan-50 to-sky-50 relative">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-5xl sm:text-6xl font-black text-center mb-6 text-gray-800">
            <span className="text-cyan-500">{t("howToBuyTitle")}</span>
          </h2>
          <div className="flex justify-center mb-12">
            <img src="https://static.lumi.new/1d/1d99b038b203d09634a7edba173408dd.webp" alt="Shikoku Inu" className="w-56 h-56 sm:w-72 sm:h-72 object-contain" />
          </div>

          <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
            {/* Step 1 */}
            <div className="bg-white rounded-3xl p-8 shadow-xl border-4 border-cyan-400 transform hover:scale-105 transition-transform">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-cyan-400 to-sky-500 rounded-full flex items-center justify-center text-2xl font-black text-white shadow-lg flex-shrink-0">
                  1
                </div>
                <div>
                  <h3 className="text-2xl font-black text-cyan-500 mb-3">{t("howToBuyStep1Title")}</h3>
                  <p className="text-lg text-gray-700 leading-relaxed">{t("howToBuyStep1Desc")}</p>
                </div>
              </div>
            </div>

            {/* Step 2 */}
            <div className="bg-white rounded-3xl p-8 shadow-xl border-4 border-cyan-400 transform hover:scale-105 transition-transform">
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-cyan-400 to-sky-500 rounded-full flex items-center justify-center text-2xl font-black text-white shadow-lg flex-shrink-0">
                  2
                </div>
                <div>
                  <h3 className="text-2xl font-black text-cyan-500 mb-3">{t("howToBuyStep2Title")}</h3>
                  <p className="text-lg text-gray-700 leading-relaxed">{t("howToBuyStep2Desc")}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section id="mission" className="py-20 px-4 relative">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-5xl sm:text-6xl font-black text-center mb-6 bg-gradient-to-r from-cyan-500 via-sky-500 to-blue-500 bg-clip-text text-transparent">
            {t("missionTitle")}
          </h2>
          <div className="flex justify-center mb-12">
            <img src="https://static.lumi.new/29/2967f0cb8bd22dd0b0288103e5d8deb7.webp" alt="Shikoku Inu Mission" className="w-56 h-56 sm:w-80 sm:h-80 object-contain" />
          </div>

          <div className="max-w-4xl mx-auto">
            <div className="bg-gradient-to-br from-cyan-400 to-sky-500 rounded-3xl p-8 sm:p-12 shadow-2xl border-4 border-white text-white">
              <div className="space-y-6 text-lg sm:text-xl leading-relaxed">
                <p className="text-2xl font-black">
                  {t("missionP1")}
                </p>
                <p className="font-bold">
                  {t("missionP2")}
                </p>
                <p className="font-bold">
                  {t("missionP3")}
                </p>
                <p className="font-bold">
                  {t("missionP4")}
                </p>
                <p className="text-xl font-black text-center mt-8">
                  {t("missionCta")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Best Friends Donation Section */}
      <section id="bestfriends" className="py-20 px-4 relative">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-4xl sm:text-5xl font-black text-center mb-3 text-gray-800">
            <span className="text-cyan-500">{t("bestFriendsTitle")}</span>
          </h2>
          <p className="text-2xl sm:text-3xl font-black text-center mb-12 bg-gradient-to-r from-pink-500 via-rose-500 to-red-500 bg-clip-text text-transparent">
            {t("bestFriendsSubtitle")}
          </p>

          <div className="max-w-4xl mx-auto">
            <div className="bg-white rounded-3xl p-8 sm:p-12 shadow-2xl border-4 border-cyan-400">
              <div className="space-y-6">
                <p className="text-lg sm:text-xl text-gray-700 leading-relaxed font-bold">
                  {t("bestFriendsDesc")}
                </p>
                
                <div className="flex justify-center py-8">
                  <img src="https://static.lumi.new/e2/e2cfb2095ed2fd4a734315cf017e2a12.webp" alt="Shikoku Inu with Heart" className="w-56 h-56 sm:w-64 sm:h-64 object-contain" />
                </div>

                <p className="text-lg sm:text-xl text-gray-700 leading-relaxed font-bold text-center">
                  {t("bestFriendsCta")}
                </p>

                <div className="flex justify-center pt-6">
                  <a
                    href="https://bestfriends.org/donate/cryptocurrency-donations"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="px-8 py-4 bg-gradient-to-r from-pink-500 via-rose-500 to-red-500 text-white font-black text-lg rounded-full shadow-xl hover:shadow-2xl transform hover:scale-105 transition-all border-4 border-white"
                  >
                    {t("donateButton")}
                  </a>
                </div>

                <div className="pt-6 text-center space-y-3">
                  <p className="text-sm text-gray-500 italic">
                    🐾 Best Friends Animal Society is a 501(c)(3) nonprofit organization 🐾
                  </p>
                  <p className="text-xs text-gray-400 italic border-t pt-3 border-gray-200">
                    {t("bestFriendsDisclaimer")}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Socials Section */}
      <section id="socials" className="py-20 px-4 bg-gradient-to-r from-cyan-50 to-sky-50 relative">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-5xl sm:text-6xl font-black text-center mb-4 text-gray-800">
            <span className="text-cyan-500">{t("socialsTitle")}</span>
          </h2>
          <p className="text-xl text-gray-600 font-bold text-center mb-16">{t("socialsSubtitle")}</p>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            {/* X / Twitter */}
            <a
              href="https://x.com/ShikokuInu_Coin"
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white rounded-3xl p-8 shadow-xl border-4 border-cyan-400 flex flex-col items-center gap-4 transform hover:scale-105 transition-all hover:border-gray-800 hover:shadow-2xl"
            >
              <div className="w-20 h-20 bg-gray-800 rounded-2xl flex items-center justify-center group-hover:bg-black transition-colors shadow-lg">
                <svg viewBox="0 0 24 24" className="w-10 h-10 text-white" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                </svg>
              </div>
              <span className="text-xl font-black text-gray-800 group-hover:text-black">X</span>
            </a>

            {/* TikTok */}
            <div className="relative bg-white rounded-3xl p-8 shadow-xl border-4 border-gray-200 flex flex-col items-center gap-4 opacity-75">
              <div className="absolute -top-3 -right-3 bg-gradient-to-r from-cyan-400 to-sky-500 text-white text-xs font-black px-3 py-1.5 rounded-full shadow-lg">
                {t("comingSoon")}
              </div>
              <div className="w-20 h-20 bg-gray-300 rounded-2xl flex items-center justify-center shadow-lg">
                <svg viewBox="0 0 24 24" className="w-10 h-10 text-white" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1V9.01a6.27 6.27 0 00-.79-.05 6.34 6.34 0 00-6.34 6.34 6.34 6.34 0 006.34 6.34 6.34 6.34 0 006.33-6.34V8.99a8.21 8.21 0 004.77 1.52V7.08a4.84 4.84 0 01-1-.39z" />
                </svg>
              </div>
              <span className="text-xl font-black text-gray-400">TikTok</span>
            </div>

            {/* Instagram */}
            <div className="relative bg-white rounded-3xl p-8 shadow-xl border-4 border-gray-200 flex flex-col items-center gap-4 opacity-75">
              <div className="absolute -top-3 -right-3 bg-gradient-to-r from-cyan-400 to-sky-500 text-white text-xs font-black px-3 py-1.5 rounded-full shadow-lg">
                {t("comingSoon")}
              </div>
              <div className="w-20 h-20 bg-gray-300 rounded-2xl flex items-center justify-center shadow-lg">
                <svg viewBox="0 0 24 24" className="w-10 h-10 text-white" fill="currentColor">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
                </svg>
              </div>
              <span className="text-xl font-black text-gray-400">Instagram</span>
            </div>

            {/* Facebook */}
            <div className="relative bg-white rounded-3xl p-8 shadow-xl border-4 border-gray-200 flex flex-col items-center gap-4 opacity-75">
              <div className="absolute -top-3 -right-3 bg-gradient-to-r from-cyan-400 to-sky-500 text-white text-xs font-black px-3 py-1.5 rounded-full shadow-lg">
                {t("comingSoon")}
              </div>
              <div className="w-20 h-20 bg-gray-300 rounded-2xl flex items-center justify-center shadow-lg">
                <svg viewBox="0 0 24 24" className="w-10 h-10 text-white" fill="currentColor">
                  <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                </svg>
              </div>
              <span className="text-xl font-black text-gray-400">Facebook</span>
            </div>
          </div>
        </div>
      </section>

      {/* Breed Info Section */}
      <section className="relative py-24 px-4 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img 
            src="https://static.lumi.new/d4/d4d6727974352bfdeb63608ec9811055.webp" 
            alt="Shikoku Beach" 
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/30 to-transparent"></div>
        </div>
        {/* Text Content */}
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <p className="text-2xl sm:text-3xl md:text-4xl font-black text-white leading-relaxed drop-shadow-lg">
            {t("breedInfo")}
          </p>
        </div>
      </section>

      {/* Vision Modal */}
      <VisionModal isOpen={visionModalOpen} onClose={() => setVisionModalOpen(false)} lang={lang} />

      {/* Footer */}
      <footer className="bg-gradient-to-r from-cyan-500 via-sky-500 to-blue-500 text-white py-12 px-4 relative">
        <div className="max-w-6xl mx-auto">
          <div className="text-center space-y-6">
            <div className="flex items-center justify-center gap-3 mb-4">
              <img 
                src="https://static.lumi.new/cf/cf424088f7c8ce8cc0950a48808d2701.webp" 
                alt="Shikoku Inu Logo"
                className="w-16 h-16 rounded-full shadow-lg object-cover"
              />
              <span className="text-4xl font-black">SHIKOKU INU</span>
            </div>

            <p className="text-xl font-bold max-w-2xl mx-auto">
              {t("footerDesc")}
            </p>

            <div className="pt-8 border-t-2 border-white/30">
              <p className="font-bold">{t("footerCopyright")}</p>
              <p className="text-sm mt-2 opacity-80">
                {t("footerDisclaimer")}
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  )
}

export default Home
